/// <amd-module name="SuiteCommerce.LookBook.Main"/>
define("SuiteCommerce.LookBook.Main", ["require", "exports", "SuiteCommerce.LookBook.Common.Configuration", "SuiteCommerce.LookBook.Common.InstrumentationHelper", "SuiteCommerce.LookBook.LookBook", "SuiteCommerce.LookBook.Look", "SuiteCommerce.LookBook.PDP"], function (require, exports, Configuration_1, InstrumentationHelper_1, LookBook, Look, PDP) {
    "use strict";
    return {
        mountToApp: function (container) {
            var environment = container.getComponent('Environment');
            InstrumentationHelper_1.InstrumentationHelper.initializeInstrumentation(container.getComponent('Environment'));
            this.initializeConfiguration(environment);
            LookBook.mountToApp(container);
            Look.mountToApp(container);
            PDP.mountToApp(container);
        },
        initializeConfiguration: function (environment) {
            Configuration_1.Configuration.environment = environment;
        },
    };
});
